/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import {
  string,
  arrayOf,
  shape,
  func,
  bool
} from 'prop-types';

import { noop } from '../../../../utils/promo-utils';
import { PromoSidecar } from '../../../promo-sidecar/PromoSidecar';
import { PromoQuickviewSectionCta } from '../promo-quickview-section-cta/PromoQuickviewSectionCta';
import '../../PromoQuickview.scss';
import './PromoQuickviewOverview.scss';

export const PromoQuickviewOverview = ({
  closeDrawer,
  overview,
  highlights,
  itemId,
  onSectionClick,
  selected,
  onSelect,
  setQuantityWarningText,
  showQuantityWarningState
}) => {
  const [renderOverview, setRenderOverview] = useState(false);
  const [isOverviewOpen, setIsOverviewOpen] = useState(false);

  if (!overview || !highlights) return null;

  return (
    <>
      <PromoQuickviewSectionCta
        setOpen={setIsOverviewOpen}
        setRender={setRenderOverview}
        clickAnalytics={onSectionClick}
        sectionName="Product Overview"
      />

      {renderOverview && (
        <PromoSidecar
          isSidecarOpen={isOverviewOpen}
          setIsSidecarOpen={setIsOverviewOpen}
          closeDrawer={closeDrawer}
          zIndex={1000}
          backText="Back to Quick View"
          itemId={itemId}
          useSidecarNav
          useSidecarCta
          selected={selected}
          onSelect={onSelect}
          setQuantityWarningText={setQuantityWarningText}
          showQuantityWarningState={showQuantityWarningState}
        >
          {/* TODO: why is there a div in an article? Unnecessary HTML nesting */}
          <article className="promo-quickview-section-sidecar">
            <div className="promo-quickview-overview">
              {overview}
              {/* TODO: why is there a ul in a div? Unnecessary HTML nesting */}
              <div className="promo-quickview-overview-highlights">
                <ul>
                  {highlights.map((highlight, i) => (
                    <li
                      key={`promo-quickview-overview-highlights__highlight-${i}`}
                      className="promo-quickview-overview-highlights__highlight"
                      dangerouslySetInnerHTML={{ __html: highlight.value }}
                    />
                  ))}
                </ul>
              </div>
            </div>
          </article>
        </PromoSidecar>
      )}
    </>
  );
};

PromoQuickviewOverview.displayName = 'PromoQuickviewOverview';

PromoQuickviewOverview.propTypes = {
  closeDrawer: func.isRequired,
  overview: string.isRequired,
  highlights: arrayOf(shape({
    value: string,
  })).isRequired,
  itemId: string.isRequired,
  onSectionClick: func,
  selected: bool.isRequired,
  onSelect: func.isRequired,
  setQuantityWarningText: func,
  showQuantityWarningState: bool
};

PromoQuickviewOverview.defaultProps = {
  onSectionClick: noop,
  setQuantityWarningText: noop,
  showQuantityWarningState: false
};
